"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CR_COUNT_ITEM_FRAGMENT = void 0;
var client_1 = require("@apollo/client");
var CRCountTypeFragment_1 = require("./CRCountTypeFragment");
exports.CR_COUNT_ITEM_FRAGMENT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment CRCountItem on CRCountItem {\n    id\n    customerCount\n    competitorCount\n    storeAudit {\n      id\n    }\n    countType {\n      ...CRCountType\n    }\n  }\n  ", "\n"], ["\n  fragment CRCountItem on CRCountItem {\n    id\n    customerCount\n    competitorCount\n    storeAudit {\n      id\n    }\n    countType {\n      ...CRCountType\n    }\n  }\n  ", "\n"])), CRCountTypeFragment_1.CR_COUNT_TYPE_FRAGMENT);
var templateObject_1;
